export default "__VITE_ASSET__RQadPwu6__"